import React, { useState, useEffect } from "react";
import firebase from "../data/firebase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faAt,
	faVideo,
	faUserFriends,
} from "@fortawesome/free-solid-svg-icons";

import "./admin.css";

const Admin = () => {
	const [agendamentos, setAgendamentos] = useState({});

	const [estudante, setEstudante] = useState("");
	const [sala, setSala] = useState("");
	const [email, setEmail] = useState("");
	const [agendamento, setAgendameto] = useState("");
	const [carregando, setCarregando] = useState(false);

	useEffect(() => {
		firebase.getAdengamentos().then((resposta) => {
			setAgendamentos(resposta);
		});
	}, []);

	const novoHorario = () => {
		const data = document.getElementById('data').value
		const hora = document.getElementById('horario').value
		const aid = document.getElementById('aid').value
		console.log(data, hora, aid)
		firebase.novoHorario(aid, data, hora)
	}

	return (
		<div className="container">
			<div className="col-6">
			<form onSubmit={event => {
				event.preventDefault()
				novoHorario()
			}}>
				<label for="aid">AID</label>
				<input id="aid" type="text" />
				<label for="data">Data</label>
				<input id="data" type="text" />
				<label for="horario">Horario</label>
				<input id="horario" type="text" />
				<input type="submit" value="cadastrar" />
			</form>
			</div>
			<div className="col-6">
				<form
					onSubmit={(event) => {
						event.preventDefault();
						setCarregando(true);
						firebase
							.agendar(agendamento, estudante, sala, email)
							.then(() => setCarregando(false));
					}}
				>
					{agendamento}
					<div class="form-group">
						<label for="exampleInputEmail1">Email</label>
						<input
							type="email"
							class="form-control"
							id="exampleInputEmail1"
							aria-describedby="emailHelp"
							placeholder="Enter email"
							onChange={(event) =>
								setEmail(event.target.value.trim())
							}
						/>
					</div>
					<div class="form-group">
						<label for="exampleInputEmail1">Estudante</label>
						<input
							type="text"
							class="form-control"
							id="exampleInputEmail1"
							aria-describedby="emailHelp"
							placeholder="Estudante"
							onChange={(event) =>
								setEstudante(event.target.value.trim())
							}
						/>
					</div>
					<div class="form-group">
						<label for="exampleInputEmail1">Sala</label>
						<input
							type="text"
							class="form-control"
							id="exampleInputEmail1"
							aria-describedby="emailHelp"
							placeholder="Token"
							onChange={(event) =>
								setSala(event.target.value.trim())
							}
						/>
					</div>

					<button type="submit" class="btn btn-primary">
						Submit
					</button>
					{carregando && (
						<div class="spinner-border" role="status">
							<span class="sr-only">Loading...</span>
						</div>
					)}
				</form>
			</div>
			<h2>Quarta, 26/06</h2>

			<div className="row">
				{agendamentos.length > 0 &&
					agendamentos.map((agendamento) => (
						<div className="col-md-4">
							<div className="cartao-de-agendamento">
								<span
									style={{ marginLeft: "5px" }}
									className="badge badge-secondary"
								>
									{agendamento.data}
								</span>
								<span class="badge badge-primary">
									{agendamento.hora}
								</span>

								{agendamento.ativo && !agendamento.disponivel && (
									<>
										<span
											onClick={() =>
												setAgendameto(agendamento.aid)
											}
											style={{ marginLeft: "5px" }}
											className="badge badge-success"
										>
											Livre
										</span>
										<div className="options">
											{!agendamento.estudante && (
												<button
													onClick={() =>
														firebase.desativarAgendamento(
															agendamento
														)
													}
													className="btn btn-danger"
												>
													Desativar
												</button>
											)}
										</div>
									</>
								)}

								{agendamento.ativo && !agendamento.livre && (
									<>
										{" "}
										<h3>{agendamento.estudante}</h3>
										<div>
											<FontAwesomeIcon icon={faAt} />
											{agendamento.email}
										</div>
										<div>
											<FontAwesomeIcon icon={faVideo} />
											<a
												href={`https://${agendamento.sala}`}
											>
												{agendamento.sala}
											</a>
										</div>
										<div className="options">
											<button className="btn btn-primary">
												Inscrever
											</button>
											<button className="btn btn-primary">
												Finalizar
											</button>
										</div>
									</>
								)}
								{!agendamento.ativo && (
									<>
										<span
											style={{ marginLeft: "5px" }}
											className="badge badge-secondary"
										>
											Inativo
										</span>
										<div className="options">
											<button
												onClick={() =>
													firebase.ativarAgendamento(
														agendamento
													)
												}
												className="btn btn-primary"
											>
												Ativar
											</button>
										</div>
									</>
								)}
							</div>
						</div>
					))}
			</div>
		</div>
	);
};

export default Admin;
